import store from '../../../../store';
export default function checkIfCanUpdate() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (scopes.includes('system_roles_update_company') || scopes.includes('system_roles_update_all')) {
    exists = true;
  }
  return exists;
}
